// src/pages/patient/PatientSignUp.jsx
import React, { useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { isAuthenticated } from "../utils/authStore";

function classNames(...arr) {
  return arr.filter(Boolean).join(" ");
}

function Icon({ name, className = "h-5 w-5" }) {
  switch (name) {
    case "user":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M12 12a5 5 0 1 0-5-5 5 5 0 0 0 5 5Z"
            stroke="currentColor"
            strokeWidth="2.2"
          />
          <path
            d="M4 21a8 8 0 0 1 16 0"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
          />
        </svg>
      );

    case "phone":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M7 3h10a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"
            stroke="currentColor"
            strokeWidth="2.2"
          />
          <path
            d="M10 18h4"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
          />
        </svg>
      );

    case "mail":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M4 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6Z"
            stroke="currentColor"
            strokeWidth="2.2"
          />
          <path
            d="m5.5 7.5 6.2 5a1 1 0 0 0 1.3 0l6.2-5"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "lock":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M7 10V8a5 5 0 0 1 10 0v2"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
          />
          <path
            d="M6 10h12a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2Z"
            stroke="currentColor"
            strokeWidth="2.2"
          />
        </svg>
      );

    case "eye":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M2.5 12s3.5-7 9.5-7 9.5 7 9.5 7-3.5 7-9.5 7-9.5-7-9.5-7Z"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 15.2A3.2 3.2 0 1 0 12 8.8a3.2 3.2 0 0 0 0 6.4Z"
            stroke="currentColor"
            strokeWidth="2.2"
          />
        </svg>
      );

    case "eyeOff":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M10.6 5.2A10.8 10.8 0 0 1 12 5c6 0 9.5 7 9.5 7a18 18 0 0 1-2.2 3.3"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
          />
          <path
            d="M6.3 6.3C3.7 8.2 2.5 12 2.5 12s3.5 7 9.5 7c1.7 0 3.2-.3 4.5-.9"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
          />
          <path
            d="M9.6 9.6A3.2 3.2 0 0 0 12 15.2"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
          />
          <path
            d="M3 3l18 18"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
          />
        </svg>
      );

    case "shield":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M12 3 20 6v6c0 5-3.4 8.3-8 9-4.6-.7-8-4-8-9V6l8-3Z"
            stroke="currentColor"
            strokeWidth="2.1"
            strokeLinejoin="round"
          />
          <path
            d="m8.8 12 2 2 4.6-5"
            stroke="currentColor"
            strokeWidth="2.1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "check":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M20 6 9 17l-5-5"
            stroke="currentColor"
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "calendar":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M7 3v3M17 3v3M4 8h16"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
          />
          <rect
            x="4"
            y="6"
            width="16"
            height="14"
            rx="2"
            stroke="currentColor"
            strokeWidth="2.2"
          />
        </svg>
      );

    case "heart":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M20.8 5.6a5.2 5.2 0 0 0-7.4 0L12 7l-1.4-1.4a5.2 5.2 0 0 0-7.4 7.4L12 21.7 20.8 13a5.2 5.2 0 0 0 0-7.4Z"
            stroke="currentColor"
            strokeWidth="2.1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "users":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M16 19a4 4 0 0 0-8 0"
            stroke="currentColor"
            strokeWidth="2.1"
            strokeLinecap="round"
          />
          <path
            d="M12 13a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
            stroke="currentColor"
            strokeWidth="2.1"
          />
          <path
            d="M20 19a3 3 0 0 0-3-3M17 7.3a3 3 0 0 1 0 5.4M4 19a3 3 0 0 1 3-3M7 7.3a3 3 0 0 0 0 5.4"
            stroke="currentColor"
            strokeWidth="2.1"
            strokeLinecap="round"
          />
        </svg>
      );

    case "clock":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <circle
            cx="12"
            cy="12"
            r="9"
            stroke="currentColor"
            strokeWidth="2.1"
          />
          <path
            d="M12 7v5l3 2"
            stroke="currentColor"
            strokeWidth="2.1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "arrowRight":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M9 6l6 6-6 6"
            stroke="currentColor"
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "arrowLeft":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M15 6l-6 6 6 6"
            stroke="currentColor"
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    default:
      return null;
  }
}

function Field({ label, hint, children, error }) {
  return (
    <div>
      <label className="text-sm font-semibold text-slate-800">{label}</label>
      {hint ? <div className="mt-1 text-xs text-slate-500">{hint}</div> : null}
      <div className="mt-2">{children}</div>
      {error ? <div className="mt-1.5 text-xs font-semibold text-rose-600">{error}</div> : null}
    </div>
  );
}

function FloatingCard({ className = "", children }) {
  return (
    <div
      className={classNames(
        "rounded-[28px] border border-slate-200/80 bg-white/90 p-4 text-slate-900 shadow-[0_24px_80px_rgba(15,23,42,0.12)] backdrop-blur-xl",
        className
      )}
    >
      {children}
    </div>
  );
}

function HeroFeature({ icon, title, text }) {
  return (
    <div className="flex gap-3">
      <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl border border-blue-100 bg-blue-50 text-blue-700">
        <Icon name={icon} className="h-5 w-5" />
      </div>
      <div>
        <div className="text-sm font-extrabold text-slate-950">{title}</div>
        <div className="mt-1 text-xs leading-5 text-slate-500">{text}</div>
      </div>
    </div>
  );
}

const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  process.env.REACT_APP_BACKEND_URL ||
  "http://localhost:8002";

export default function PatientSignUp() {
  const navigate = useNavigate();
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(false);
  const [registeredEmail, setRegisteredEmail] = useState("");

  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    password: "",
    terms_accepted: false,
  });

  const input =
    "w-full rounded-2xl border border-slate-200 bg-white px-4 py-3.5 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-primary focus:ring-4 focus:ring-primary/10 disabled:bg-slate-50 disabled:text-slate-500";
  const inputWithIcon = (pad = "pl-12") => classNames(input, pad);

  const phoneOk = useMemo(() => {
    const p = form.phone.replace(/\s+/g, "");
    if (!p) return true;
    return /^[0-9+()-]{10,15}$/.test(p);
  }, [form.phone]);

  const passwordStrength = useMemo(() => {
    if (!form.password) return 0;

    let strength = 0;
    if (form.password.length >= 8) strength += 1;
    if (/[A-Z]/.test(form.password)) strength += 1;
    if (/[0-9]/.test(form.password)) strength += 1;
    if (/[^A-Za-z0-9]/.test(form.password)) strength += 1;

    return strength;
  }, [form.password]);

  React.useEffect(() => {
    if (isAuthenticated()) {
      navigate("/patient/dashboard");
    }
  }, [navigate]);

  function updateField(key, value) {
    setForm((p) => ({ ...p, [key]: value }));
    setErrors((p) => ({ ...p, [key]: undefined, submit: undefined }));
  }

  function validateForm() {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!form.first_name.trim()) {
      newErrors.first_name = "First name is required.";
    }

    if (!form.last_name.trim()) {
      newErrors.last_name = "Last name is required.";
    }

    if (!form.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!emailRegex.test(form.email)) {
      newErrors.email = "Please enter a valid email address.";
    }

    if (!phoneOk && form.phone.trim()) {
      newErrors.phone = "Please enter a valid phone number.";
    }

    if (!form.password) {
      newErrors.password = "Password is required.";
    } else if (form.password.length < 8) {
      newErrors.password = "Password must be at least 8 characters.";
    }

    if (!form.terms_accepted) {
      newErrors.terms_accepted = "You must agree to the Terms and Privacy Policy.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (!validateForm()) return;

    setLoading(true);
    setErrors({});
    setSuccess(false);

    try {
      const response = await fetch(`${API_BASE_URL}/api/v1/patients/register`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          first_name: form.first_name.trim(),
          last_name: form.last_name.trim(),
          email: form.email.trim(),
          phone: form.phone || "",
          password: form.password,
          terms_accepted: form.terms_accepted,
        }),
      });

      const data = await response.json().catch(() => ({}));

      if (response.ok) {
        setSuccess(true);
        setRegisteredEmail(form.email.trim());

        setForm({
          first_name: "",
          last_name: "",
          email: "",
          phone: "",
          password: "",
          terms_accepted: false,
        });
      } else if (response.status === 409) {
        setErrors({
          submit: "Email already registered. Please sign in or use a different email.",
        });
      } else if (response.status === 422) {
        const detail = data.detail;
        setErrors({
          submit: Array.isArray(detail)
            ? detail.map((d) => d.msg).join(", ")
            : detail || "Invalid data. Please check your information.",
        });
      } else {
        setErrors({
          submit:
            data.detail ||
            data.message ||
            data.error ||
            `Registration failed. Status: ${response.status}`,
        });
      }
    } catch (error) {
      console.error("Registration error:", error);
      setErrors({
        submit: "Network error. Please check your internet connection.",
      });
    } finally {
      setLoading(false);
    }
  }

  function resetForm() {
    setSuccess(false);
    setRegisteredEmail("");
    setErrors({});
  }

  return (
    <main className="h-screen overflow-hidden bg-slate-50">
      <div className="grid h-screen grid-cols-1 lg:grid-cols-12">
        {/* LEFT VISUAL SIDE */}
        <section className="relative hidden h-screen overflow-hidden bg-white lg:col-span-7 lg:block">
          <div className="absolute -left-28 bottom-[-140px] h-[420px] w-[420px] rounded-full bg-blue-200/45 blur-3xl" />
          <div className="absolute right-[-120px] top-[-120px] h-[360px] w-[360px] rounded-full bg-cyan-200/45 blur-3xl" />
          <div className="absolute left-[58%] top-[18%] h-[240px] w-[240px] rounded-full bg-violet-200/35 blur-3xl" />

          <div className="absolute inset-0 opacity-[0.42]">
            <svg className="h-full w-full" viewBox="0 0 900 900" fill="none">
              <defs>
                <pattern
                  id="signup-grid"
                  width="44"
                  height="44"
                  patternUnits="userSpaceOnUse"
                >
                  <path
                    d="M44 0H0V44"
                    stroke="#2563EB"
                    strokeWidth="1"
                    opacity="0.16"
                  />
                </pattern>
              </defs>
              <rect width="900" height="900" fill="url(#signup-grid)" />
            </svg>
          </div>

          <svg
            className="absolute left-[6%] top-[21%] h-[280px] w-[88%] opacity-35"
            viewBox="0 0 900 260"
            fill="none"
          >
            <path
              d="M0 145 C110 80 190 80 280 140 C350 188 410 185 455 110 L480 210 L515 65 L545 148 C590 145 620 145 675 110 C760 55 835 50 900 80"
              stroke="#2563EB"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              d="M0 176 C120 130 215 125 310 166 C405 205 490 205 585 158 C710 96 805 96 900 122"
              stroke="#06B6D4"
              strokeWidth="1.8"
              strokeLinecap="round"
              opacity="0.55"
            />
          </svg>

          <div className="absolute left-[60%] top-[12%] text-4xl font-black text-blue-200">
            +
          </div>
          <div className="absolute right-[9%] top-[32%] text-5xl font-black text-cyan-200">
            +
          </div>
          <div className="absolute left-[48%] bottom-[21%] text-3xl font-black text-violet-200">
            +
          </div>

          <div className="relative z-10 flex h-screen flex-col px-10 py-9 xl:px-14">
            <div className="flex items-center gap-4">
              <img
                src="/images/logo.png"
                alt="ThePulseCare"
                className="h-14 w-auto object-contain"
              />
              <div>
                <div className="text-2xl font-extrabold tracking-tight text-slate-950">
                  ThePulseCare
                </div>
                <div className="text-sm font-bold text-slate-500">
                  Patient Portal
                </div>
              </div>
            </div>

            <div className="mt-20 max-w-2xl">
              <h1 className="text-6xl font-black leading-[0.98] tracking-tight text-slate-950 xl:text-7xl">
                Start your
                <br />
                care journey
                <br />
                <span className="bg-gradient-to-r from-blue-700 via-sky-500 to-cyan-500 bg-clip-text text-transparent">in minutes</span>
              </h1>

              <p className="mt-7 max-w-xl text-lg leading-8 text-slate-600">
                Create your secure patient account to book doctors, complete
                pre-visit forms, join online consultations, and manage your
                appointments in one place.
              </p>
            </div>

            <FloatingCard className="absolute right-[11%] top-[22%] w-[285px]">
              <div className="text-xs font-bold text-slate-500">
                Quick onboarding
              </div>
              <div className="mt-3 flex items-center gap-3">
                <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-blue-50 text-blue-700">
                  <Icon name="user" className="h-6 w-6" />
                </div>
                <div>
                  <div className="text-sm font-black text-slate-950">Create account</div>
                  <div className="text-xs text-slate-500">Verify your email</div>
                </div>
              </div>
              <div className="mt-4 grid grid-cols-3 gap-2">
                <div className="h-2 rounded-full bg-blue-600" />
                <div className="h-2 rounded-full bg-blue-600/70" />
                <div className="h-2 rounded-full bg-blue-600/30" />
              </div>
            </FloatingCard>

            <FloatingCard className="absolute right-[5%] top-[47%] w-[310px]">
              <div className="flex items-center gap-3">
                <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-violet-50 text-violet-600">
                  <Icon name="heart" className="h-6 w-6" />
                </div>
                <div>
                  <div className="text-sm font-black text-slate-950">Patient-ready profile</div>
                  <div className="text-xs text-slate-500">
                    Appointments, forms, visits
                  </div>
                </div>
              </div>
              <div className="mt-4 rounded-2xl border border-blue-100 bg-blue-50 p-3">
                <div className="flex items-center justify-between text-xs">
                  <span className="text-slate-500">Profile setup</span>
                  <span className="font-black text-blue-700">Fast</span>
                </div>
                <div className="mt-3 h-2 rounded-full bg-blue-100">
                  <div className="h-2 w-3/4 rounded-full bg-blue-600" />
                </div>
              </div>
            </FloatingCard>

            <div className="absolute left-[10%] bottom-[23%] hidden h-40 w-40 rounded-full border border-blue-100 bg-white/70 backdrop-blur-xl xl:block">
              <div className="flex h-full items-center justify-center text-blue-700">
                <Icon name="shield" className="h-16 w-16" />
              </div>
            </div>

            <div className="mt-auto grid grid-cols-3 gap-5 border-t border-slate-200/80 pt-8">
              <HeroFeature
                icon="shield"
                title="Secure account"
                text="Your health and booking details stay protected."
              />
              <HeroFeature
                icon="calendar"
                title="Easy appointments"
                text="Find services and book visits faster."
              />
              <HeroFeature
                icon="clock"
                title="Always ready"
                text="Manage care anytime from your portal."
              />
            </div>
          </div>
        </section>

        {/* RIGHT SIDE */}
        <section className="relative h-screen overflow-y-auto px-5 sm:px-8 lg:col-span-5 lg:px-10">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(14,165,233,0.13),transparent_35%),radial-gradient(circle_at_bottom_left,rgba(124,58,237,0.10),transparent_30%)]" />

          <div className="relative flex min-h-full items-center justify-center py-8">
            <div className="w-full max-w-[560px]">
            <div className="mb-8 flex items-center justify-center gap-3 lg:hidden">
              <img
                src="/images/logo.png"
                alt="ThePulseCare"
                className="h-12 w-auto object-contain"
              />
              <div>
                <div className="text-xl font-extrabold text-slate-950">
                  ThePulseCare
                </div>
                <div className="text-xs text-slate-500">Patient Portal</div>
              </div>
            </div>

            {success ? (
              <div className="overflow-hidden rounded-[32px] border border-white/80 bg-white/90 shadow-[0_24px_80px_rgba(15,23,42,0.13)] backdrop-blur-xl">
                <div className="p-8 text-center sm:p-10">
                  <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-emerald-100 text-emerald-600">
                    <Icon name="check" className="h-10 w-10" />
                  </div>

                  <h2 className="mt-6 text-3xl font-black tracking-tight text-slate-950">
                    Check your email
                  </h2>

                  <p className="mx-auto mt-3 max-w-sm text-sm leading-6 text-slate-500">
                    We sent a verification link to activate your ThePulseCare
                    patient account.
                  </p>

                  <div className="mt-5 rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 font-mono text-sm font-semibold text-slate-700">
                    {registeredEmail}
                  </div>

                  <div className="mt-6 rounded-3xl border border-sky-100 bg-sky-50 p-5 text-left">
                    <div className="text-sm font-bold text-sky-900">
                      What to do next
                    </div>

                    <div className="mt-4 space-y-3 text-sm text-sky-800">
                      {[
                        "Open your inbox and find the verification email.",
                        "Click the verification link to activate your account.",
                        "Check spam or promotions if you do not see it.",
                        "The link may expire for security, so verify soon.",
                      ].map((text, idx) => (
                        <div key={text} className="flex gap-3">
                          <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-blue-600 text-xs font-black text-sky-700">
                            {idx + 1}
                          </span>
                          <span>{text}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="mt-7 space-y-3">
                    <button
                      onClick={() => navigate("/signin")}
                      className="w-full rounded-2xl bg-gradient-to-r from-blue-600 via-sky-500 to-cyan-500 px-6 py-4 text-sm font-extrabold text-white shadow-[0_16px_40px_rgba(37,99,235,0.26)] transition hover:-translate-y-0.5"
                    >
                      Go to sign in
                    </button>

                    <button
                      onClick={resetForm}
                      className="w-full rounded-2xl border border-slate-200 bg-white px-6 py-4 text-sm font-extrabold text-slate-700 transition hover:bg-slate-50"
                    >
                      Register another account
                    </button>
                  </div>

                  <div className="mt-6 border-t border-slate-100 pt-5 text-xs leading-5 text-slate-500">
                    Didn&apos;t receive the email? Contact{" "}
                    <a
                      href="mailto:support@thepulsecare.com"
                      className="font-bold text-primary hover:underline"
                    >
                      support@thepulsecare.com
                    </a>
                  </div>
                </div>
              </div>
            ) : (
              <div className="overflow-hidden rounded-[32px] border border-white/80 bg-white/90 shadow-[0_24px_80px_rgba(15,23,42,0.13)] backdrop-blur-xl">
                <div className="p-7 sm:p-9">
                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    className="mb-6 inline-flex items-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-2.5 text-sm font-bold text-slate-700 transition hover:bg-slate-50"
                  >
                    <Icon name="arrowLeft" className="h-4 w-4" />
                    Back
                  </button>

                  <div>
                    <div className="inline-flex items-center gap-2 rounded-full border border-sky-100 bg-sky-50 px-3 py-1 text-xs font-bold text-sky-700">
                      <span className="h-2 w-2 rounded-full bg-emerald-500" />
                      Create secure patient account
                    </div>

                    <h2 className="mt-5 text-4xl font-black tracking-tight text-slate-950">
                      Create account
                    </h2>

                    <p className="mt-3 max-w-sm text-base leading-7 text-slate-500">
                      Join ThePulseCare to book appointments, fill forms, and
                      manage your care securely.
                    </p>
                  </div>

                  <form onSubmit={handleSubmit} className="mt-8 space-y-5">
                    {errors.submit ? (
                      <div className="rounded-2xl border border-rose-200 bg-rose-50 p-4">
                        <div className="text-sm font-semibold text-rose-700">
                          {errors.submit}
                        </div>
                      </div>
                    ) : null}

                    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                      <Field label="First name" error={errors.first_name}>
                        <div className="relative">
                          <span className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400">
                            <Icon name="user" className="h-5 w-5" />
                          </span>
                          <input
                            value={form.first_name}
                            onChange={(e) =>
                              updateField("first_name", e.target.value)
                            }
                            className={classNames(
                              inputWithIcon(),
                              errors.first_name &&
                                "border-rose-300 focus:border-rose-400 focus:ring-rose-100"
                            )}
                            placeholder="Peter"
                            required
                            disabled={loading}
                          />
                        </div>
                      </Field>

                      <Field label="Last name" error={errors.last_name}>
                        <input
                          value={form.last_name}
                          onChange={(e) =>
                            updateField("last_name", e.target.value)
                          }
                          className={classNames(
                            input,
                            errors.last_name &&
                              "border-rose-300 focus:border-rose-400 focus:ring-rose-100"
                          )}
                          placeholder="Miller"
                          required
                          disabled={loading}
                        />
                      </Field>
                    </div>

                    <Field
                      label="Email address"
                      hint="We will send a verification email to this address."
                      error={errors.email}
                    >
                      <div className="relative">
                        <span className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400">
                          <Icon name="mail" className="h-5 w-5" />
                        </span>
                        <input
                          value={form.email}
                          onChange={(e) => updateField("email", e.target.value)}
                          type="email"
                          className={classNames(
                            inputWithIcon(),
                            errors.email &&
                              "border-rose-300 focus:border-rose-400 focus:ring-rose-100"
                          )}
                          placeholder="you@example.com"
                          required
                          disabled={loading}
                        />
                      </div>
                    </Field>

                    <Field
                      label="Phone"
                      hint="Optional. Used for appointment updates."
                      error={errors.phone}
                    >
                      <div className="relative">
                        <span className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400">
                          <Icon name="phone" className="h-5 w-5" />
                        </span>
                        <input
                          value={form.phone}
                          onChange={(e) => updateField("phone", e.target.value)}
                          className={classNames(
                            inputWithIcon(),
                            errors.phone &&
                              "border-rose-300 focus:border-rose-400 focus:ring-rose-100"
                          )}
                          placeholder="+1 (555) 123-4567"
                          disabled={loading}
                        />
                      </div>
                    </Field>

                    <Field
                      label="Password"
                      hint="Use 8+ characters. Add numbers and symbols for better security."
                      error={errors.password}
                    >
                      <div className="relative">
                        <span className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400">
                          <Icon name="lock" className="h-5 w-5" />
                        </span>

                        <input
                          value={form.password}
                          onChange={(e) =>
                            updateField("password", e.target.value)
                          }
                          type={showPw ? "text" : "password"}
                          className={classNames(
                            inputWithIcon("pl-12 pr-14"),
                            errors.password &&
                              "border-rose-300 focus:border-rose-400 focus:ring-rose-100"
                          )}
                          placeholder="Create a strong password"
                          required
                          minLength={8}
                          disabled={loading}
                        />

                        <button
                          type="button"
                          onClick={() => setShowPw((s) => !s)}
                          className="absolute right-3 top-1/2 -translate-y-1/2 rounded-xl p-2 text-slate-400 transition hover:bg-slate-100 hover:text-slate-700 disabled:opacity-50"
                          title={showPw ? "Hide password" : "Show password"}
                          disabled={loading}
                        >
                          <Icon
                            name={showPw ? "eyeOff" : "eye"}
                            className="h-5 w-5"
                          />
                        </button>
                      </div>

                      {form.password ? (
                        <div className="mt-3">
                          <div className="flex gap-1">
                            {[1, 2, 3, 4].map((i) => (
                              <div
                                key={i}
                                className={classNames(
                                  "h-1.5 flex-1 rounded-full transition",
                                  i <= passwordStrength
                                    ? passwordStrength >= 3
                                      ? "bg-emerald-500"
                                      : passwordStrength >= 2
                                      ? "bg-amber-500"
                                      : "bg-rose-500"
                                    : "bg-slate-200"
                                )}
                              />
                            ))}
                          </div>

                          <div className="mt-1 text-xs font-semibold text-slate-500">
                            {passwordStrength === 0
                              ? "Enter password"
                              : passwordStrength === 1
                              ? "Weak"
                              : passwordStrength === 2
                              ? "Fair"
                              : passwordStrength === 3
                              ? "Good"
                              : "Strong"}
                          </div>
                        </div>
                      ) : null}
                    </Field>

                    <div
                      className={classNames(
                        "rounded-2xl border bg-slate-50 p-4",
                        errors.terms_accepted
                          ? "border-rose-300"
                          : "border-slate-200"
                      )}
                    >
                      <label className="flex cursor-pointer items-start gap-3">
                        <input
                          type="checkbox"
                          className="mt-1 h-4 w-4 rounded border-slate-300 text-primary focus:ring-primary"
                          checked={form.terms_accepted}
                          onChange={(e) =>
                            updateField("terms_accepted", e.target.checked)
                          }
                          disabled={loading}
                        />
                        <div className="text-sm">
                          <div className="font-bold text-slate-800">
                            I agree to the Terms and Privacy Policy
                          </div>
                          <div className="mt-1 text-xs leading-5 text-slate-500">
                            We use your details only for appointments, forms,
                            billing, communication, and account security.
                          </div>

                          {errors.terms_accepted ? (
                            <div className="mt-2 text-xs font-semibold text-rose-600">
                              {errors.terms_accepted}
                            </div>
                          ) : null}
                        </div>
                      </label>
                    </div>

                    <button
                      type="submit"
                      disabled={!form.terms_accepted || !phoneOk || loading}
                      className="group flex w-full items-center justify-center gap-3 rounded-2xl bg-gradient-to-r from-blue-600 via-sky-500 to-cyan-500 px-6 py-4 text-sm font-extrabold text-white shadow-[0_16px_40px_rgba(37,99,235,0.28)] transition hover:-translate-y-0.5 hover:shadow-[0_20px_50px_rgba(37,99,235,0.34)] disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:translate-y-0"
                    >
                      {loading ? (
                        <>
                          <svg
                            className="h-5 w-5 animate-spin text-white"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                            />
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            />
                          </svg>
                          Creating account...
                        </>
                      ) : (
                        <>
                          Create account
                          <Icon
                            name="arrowRight"
                            className="h-5 w-5 transition group-hover:translate-x-1"
                          />
                        </>
                      )}
                    </button>

                    <div className="text-center text-sm text-slate-500">
                      Already have an account?{" "}
                      <Link
                        to="/signin"
                        className="font-extrabold text-primary hover:underline"
                      >
                        Sign in
                      </Link>
                    </div>
                  </form>
                </div>

                <div className="border-t border-slate-100 bg-slate-50/80 px-7 py-5 sm:px-9">
                  <div className="flex items-center gap-3">
                    <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-white text-slate-500 shadow-sm">
                      <Icon name="shield" className="h-5 w-5" />
                    </div>
                    <div>
                      <div className="text-sm font-bold text-slate-800">
                        Secure onboarding
                      </div>
                      <div className="mt-0.5 text-xs leading-5 text-slate-500">
                        Your information is used to create your account,
                        support appointments, and protect your patient profile.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {!success ? (
              <div className="mt-6 text-center text-xs text-slate-400">
                By creating an account, you agree to ThePulseCare&apos;s Terms
                and Privacy Policy.
              </div>
            ) : null}
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}